import { Entity } from '@backstage/catalog-model';

/** Namespace all CNPG clusters live in when an entity does not say otherwise. */
const DEFAULT_CNPG_NAMESPACE = 'cnpg-clusters';

export type ClusterRef = {
  namespace: string;
  cluster: string;
};

/**
 * Resolves the Kubernetes coordinates of the cluster an entity describes.
 *
 * Templates stamp `database/namespace` and `database/cluster`, but entities
 * registered before those annotations existed only have their own name, so fall
 * back to that.
 */
export function getClusterRef(entity: Entity): ClusterRef {
  const ann = entity.metadata.annotations ?? {};
  return {
    namespace: ann['database/namespace'] || DEFAULT_CNPG_NAMESPACE,
    cluster: ann['database/cluster'] || entity.metadata.name,
  };
}

/** True for catalog Resources that represent a managed database. */
export function isDatabaseResource(entity: Entity): boolean {
  return (
    entity.kind === 'Resource' &&
    (entity.spec?.type as string | undefined)?.toLowerCase() === 'database'
  );
}
